export default __webpack_public_path__ + "static/media/panaviera.5cf62a19.png";